var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no_data"},[_c('img',{attrs:{"src":require("./img/empty.png"),"alt":""}}),_vm._t("default"),_vm._t("btn")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }